// All colors app

export const IconFireOffColor = "coral"; 
export const IconFireOnColor = "cornflowerblue"; 
export const BackgroundColorPrimary = "#FFF";
export const PrimaryColor = "cornflowerblue";
export const SecundaryColor = "coral";
export const BorderColor = "#eee";
